import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TiendaPaquete } from "../../services/tienda-paquetes/tienda-paquete.types";

export type TiendaPaqueteState = {
  tiendaPaquetes: TiendaPaquete[];
  loading: boolean;
};

const initialState: TiendaPaqueteState = {
  tiendaPaquetes: [],
  loading: false,
};

const tiendaPaqueteSlice = createSlice({
  name: "tiendaPaquete",
  initialState,
  reducers: {
    clearTiendaPaquetes: (state) => {
      state.tiendaPaquetes = [];
      state.loading = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setTiendaPaquetes: (state, action: PayloadAction<TiendaPaquete[]>) => {
      state.tiendaPaquetes = action.payload;
      state.loading = false;
    },
    addTiendaPaquete: (state, action: PayloadAction<TiendaPaquete>) => {
      state.tiendaPaquetes.unshift(action.payload);
    },
    updateTiendaPaquete: (
      state,
      action: PayloadAction<{ id: number; data: TiendaPaquete }>
    ) => {
      const index = state.tiendaPaquetes.findIndex(
        (p) => p.id === action.payload.id
      );
      if (index !== -1) {
        state.tiendaPaquetes[index] = action.payload.data;
      }
    },
    deleteTiendaPaquete: (state, action: PayloadAction<number>) => {
      state.tiendaPaquetes = state.tiendaPaquetes.filter(
        (p) => p.id !== action.payload
      );
    },
  },
});

export default tiendaPaqueteSlice;
export const {
  clearTiendaPaquetes,
  setLoading,
  setTiendaPaquetes,
  addTiendaPaquete,
  updateTiendaPaquete,
  deleteTiendaPaquete,
} = tiendaPaqueteSlice.actions;
